import React, { useState, useEffect } from "react";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import {
    SITELOCATION_GLOBAL_STATE,
    SiteSetupAction,
    MAP_GLOBAL_STATES,
    SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { useHookstate } from "@hookstate/core";
import { isUserBasic, isUserReadOnly, siteSettingsTypes } from "../../../constant";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { displayHideAreaPolygon } from "../functions/displayHideAreaPolygon";
import { hidePolygon } from "../functions/hidePolygon";
import { displayPolygon } from "../functions/displayPolygon";
import { uuid } from "_helperFunctions/uuid";
import { MapCenterMarker, MapTeesMarker, MapPointMarker, MapHoleMarker, NewMapPointMarker, NewMapTeesMarker } from "../MapIcons";
import { kmlLayerData as kmlLayerDataAction } from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import { openEditModal } from "../functions/events/openEditModal";

export const SiteAreaMarkers = ({
    mapData,
    mapsData,
    teeMarkersDataState,
    setTeeMarkersDataState,
    pointsOfInterestDataState,
    setPointsOfInterestDataState,
    centerGreenDataState,
    setCenterGreenDataState,
    setOpenModel,
    setOpenAreaWindow,
    setHoleCount,
    holeNo,
    imagePreview,
    setOpenSiteAreaWindow,
    setTempPolygon,
    teeMarkeSeetingId,
    setTeeMarkerSeetingId,
    ourData,
    setTempSiteEdit,
    setIsTempPolygon,
    setEditModel,
    setFinalDataState,
    setCarSnackbarInfo,
    setCTDModal,
    showHoleMarker,
    poiTypeValue,
    poiPositionValue,
    teeValue,
    holePolygons,
    areaPolygons,
    editSelectedData,
    courseNameModel,
    holeNoModel,
    siteSetupState,
    teesAreaPathState,
    teesPathCoordsState,
    fwysAreaPathState,
    fwysPathCoordsState,
    gmsAreaPathState,
    gmsPathCoordsState,
    extsAreaPathState,
    extsPathCoordsState,
    stgsAreaPathState,
    stgsPathCoordsState,
    addListenersOnEditAreaFinalPolygon,
    addListenersOnEditSiteAreaChangesPolygon,
    addListenersOnEditSiteAreaFinalPolygon,
    teesZoneDisplayed,
    fwysZoneDisplayed,
    gmsZoneDisplayed,
    extsZoneDisplayed,
    stgsZoneDisplayed,
    holeAreaDrawingEventListenerAdding,
    resetHoleAreaForm,
    siteDrawAreaPolygon,
    drawAreaPolygon,
    setTeesZoneDisplayed,
    setGmsZoneDisplayed,
    setFwysZoneDisplayed,
    setStgsZoneDisplayed,
    setExtsZoneDisplayed,
    snackbarState,
    setSnackbarState,
    setSiteSetupState,
    setEditSelectedData,
    setTeesAreaPathState,
    setTeesPathCoords,
    setStgsAreaPathState,
    setStgsPathCoords,
    setFwysAreaPathState,
    setFwysPathCoords,
    setGmsAreaPathState,
    setGmsPathCoords,
    setExtsAreaPathState,
    setExtsPathCoords,
    removeAddPolygon,
    cancelMarkers,
    setCourseNameModel,
    setHoleNoModel,
    setCourseTypeModel,
    clickWindowState,
    carPopupClickEvent,
    setSetting,
    setModalState,
    setEditId,
    setEditLatLng,
    setDeleteId,
    setPoiEditTypeValue,
    setPoiEditTypeCopy,
    setEditHoleNo,
    handleEditCourseChange,
    setSiteSetupDialogBox,
    siteAreaDrawingEventListenerAdding
}) => {
    const dispatch = useDispatch();

    const {
        siteSetupData,
        holeMarkerData,
        getUserRole,
        kmlLayerData
    } = useSelector((state) => state.commonReducers) || [];

    const { areaFilterData } = useSelector((state) => state.firstReducer);

    const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);
    const {
        showAreas,
        showCenterOfGreens,
        showTeeMarkers,
        showPointsOfInterest,
        teesBtn,
        gmsBtn,
        fwysBtn,
        hideAll,
        stgsBtn,
        addSiteSetup,
        editSiteSetup,
        addSelectType,
        extsBtn,
        holeView,
        showSiteData,
        areaModified,
        isSaveSiteArea,
        isSaveHoleArea,
        holeChange,
        showAll,
        refreshSiteSetupAreas,
        typeHole
    } = useHookstate(SiteSetupAction);

    const {
        enableClickToDriveFeature,
        showTaggedCarArrayClickToDriveInputValueSetter,
        mapSideNavTabState,
        subNavDataState,
        editActionZonePolygonData,
        actionZoneModified,
        overlay
    } = useHookstate(MAP_GLOBAL_STATES);
    const { siteId, selectSite } = useHookstate(SITEID_GLOBAL_STATE);

    const siteIdValue = siteId.get();

    const [teesZoneState, setTeesZoneState] = useState();
    const [gmsZoneState, setGmsZoneState] = useState();
    const [fwysZoneState, setFwysZoneState] = useState();
    const [extsZoneState, setExtsZoneState] = useState();
    const [editState, seteditState] = useState({ editStage: false, polygonType: null });
    const [displayKmlLayer, setDisplayKmlLayer] = useState();

    useEffect(() => {
        const configList = [
            {
                btn: teesBtn,
                areaPathState: teesAreaPathState,
                pathCoordsState: teesPathCoordsState,
                zoneDisplayed: teesZoneDisplayed,
                setZoneDisplayed: setTeesZoneDisplayed,
                color: "#eb0c0a",
                id: 2
            },
            {
                btn: gmsBtn,
                areaPathState: gmsAreaPathState,
                pathCoordsState: gmsPathCoordsState,
                zoneDisplayed: gmsZoneDisplayed,
                setZoneDisplayed: setGmsZoneDisplayed,
                color: "#067c05",
                id: 3
            },
            {
                btn: fwysBtn,
                areaPathState: fwysAreaPathState,
                pathCoordsState: fwysPathCoordsState,
                zoneDisplayed: fwysZoneDisplayed,
                setZoneDisplayed: setFwysZoneDisplayed,
                color: "#f0f004",
                id: 4
            },
            {
                btn: extsBtn,
                areaPathState: extsAreaPathState,
                pathCoordsState: extsPathCoordsState,
                zoneDisplayed: extsZoneDisplayed,
                setZoneDisplayed: setExtsZoneDisplayed,
                color: "#0202f2",
                id: 1
            },
            {
                btn: stgsBtn,
                areaPathState: stgsAreaPathState,
                pathCoordsState: stgsPathCoordsState,
                zoneDisplayed: stgsZoneDisplayed,
                setZoneDisplayed: setStgsZoneDisplayed,
                color: "#663a83",
                id: 5
            }
        ];

        configList.forEach(config => {
            displayHideAreaPolygon(
                config.btn.get(),
                config.areaPathState,
                config.pathCoordsState,
                config.zoneDisplayed,
                config.setZoneDisplayed,
                config.color,
                config.id,
                mapData,
                mapsData,
                addListenersOnEditSiteAreaChangesPolygon,
                addListenersOnEditSiteAreaFinalPolygon,
                addListenersOnEditAreaFinalPolygon,
                polygonClick,
                polyMouseOver,
                polyMouseOut,
                showAreas.get()
            );
        });
    }, [
        teesBtn.get(),
        gmsBtn.get(),
        fwysBtn.get(),
        extsBtn.get(),
        stgsBtn.get()
    ]);

    useEffect(() => {
        if (!holeChange.get()) callPolygonForSiteSetup();
    }, [hideAll.get(), showAll.get(), showAreas.get()]);

    useEffect(() => {
        if (holeChange.get() && showAreas.get()) {
            const polyTypes = ["exts", "tees", "gms", "fwys"];
            const color = ["#0202f2", "#eb0c0a", "#067c05", "#f0f004"];

            polyTypes.map((item, i) =>
                hidePolygon(
                    eval(item + "ZoneDisplayed"),
                    eval(
                        "set" +
                        item.charAt(0).toUpperCase() +
                        item.slice(1) +
                        "ZoneDisplayed"
                    )
                )
            );

            polyTypes.map((item, i) => {
                if (
                    (item === "exts" && extsBtn.get()) ||
                    (item === "tees" && teesBtn.get()) ||
                    (item === "gms" && gmsBtn.get()) ||
                    (item === "fwys" && fwysBtn.get())
                ) {
                    displayPolygon(
                        eval(item + "AreaPathState"),
                        eval(item + "PathCoordsState"),
                        eval(
                            "set" +
                            item.charAt(0).toUpperCase() +
                            item.slice(1) +
                            "ZoneDisplayed"
                        ),
                        color[i],
                        i + 1,
                        mapData,
                        mapsData,
                        addListenersOnEditSiteAreaChangesPolygon,
                        addListenersOnEditSiteAreaFinalPolygon,
                        addListenersOnEditAreaFinalPolygon,
                        polygonClick,
                        polyMouseOver,
                        polyMouseOut
                    );
                }
            });
        }
    }, [fwysAreaPathState]);

    useEffect(() => {
        if (holeView.get()) showAll.set(true);
    }, [extsPathCoordsState]);

    useEffect(() => {
        if (refreshSiteSetupAreas.get()) {
            showAreas.set(!showAreas.get());
            setTimeout(() => {
                showAreas.set(!showAreas.get());
            }, 30);
        }
        refreshSiteSetupAreas.set(false);
    }, [refreshSiteSetupAreas.get()]);

    useEffect(() => {
        if (mapSideNavTabState.get() !== "Site Setup" || editSiteSetup.get()) {
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            cancelMarkers();
            addSiteSetup.set(false);

            areaModified.set(false);
            setTempPolygon([]);
            siteDrawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            siteDrawAreaPolygon?.setMap(null);
            drawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            drawAreaPolygon?.setMap(null);
            areaPolygons.forEach((it) => it.setMap(null));
            holePolygons.forEach((it) => it.setMap(null));
        }
    }, [mapSideNavTabState.get(), editSiteSetup.get(), subNavDataState.get()]);

    useEffect(() => {
        editActionZonePolygonData.set(null);
        setOpenSiteAreaWindow(false);
        setOpenAreaWindow(false);
        setOpenModel(false);
        actionZoneModified.set(false);
        cancelMarkers();
    }, [siteId.get()]);

    useEffect(() => {
        if (selectSite.get()) {
            setEditModel(false);
            setOpenModel(false);
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            addSiteSetup.set(false);

            holePolygons.forEach((it) => it.setMap(null));
            areaPolygons.forEach((it) => it.setMap(null));
        }
    }, [selectSite.get()]);

    useEffect(() => {
        if (addSiteSetup.get()) {
            showAreas.set(!showAreas.get());
            setTimeout(() => {
                showAreas.set(!showAreas.get());
            }, 0);
            setOpenSiteAreaWindow(false);
            showSiteData.set(true);
            setSiteSetupState(siteSetupData);

            if (isSaveSiteArea.get()) {
                areaPolygons.forEach((it) => it.setMap(null));
                siteAreaDrawingEventListenerAdding();
            }

            if (isSaveHoleArea.get()) {
                setTempPolygon([]);
                holePolygons.forEach((it) => it.setMap(null));
                resetHoleAreaForm();
                holeAreaDrawingEventListenerAdding();
            }

            isSaveSiteArea.set(false);
            isSaveHoleArea.set(false);
        }
    }, [siteSetupData]);

    useEffect(() => {
        if (editSiteSetup.get()) {
            showSiteData.set(true);
            setSiteSetupState(siteSetupData);
            setTempSiteEdit([]);
            setIsTempPolygon(false);

            let imageData = {
                courseNumber: courseNameModel,
                holeNumber: holeNoModel,
                siteIdValue,
            };
            imagePreview(imageData);
            showAreas.set(!showAreas.get());
            setTimeout(() => {
                showAreas.set(!showAreas.get());
            }, 0);
            areaModified.set(false);
            editSelectedData?.setOptions({
                editable: false,
                fillOpacity: 0.6,
            });

            if (isSaveSiteArea.get()) {
                setOpenSiteAreaWindow(false);
            }

            if (isSaveHoleArea.get()) {
                setOpenAreaWindow(false);
                resetHoleAreaForm();
            }

            isSaveSiteArea.set(false);
            isSaveHoleArea.set(false);
        }
    }, [siteSetupData]);

    useEffect(() => {
        if (Object.keys(siteSetupState).length > 0) {
            setCenterGreenDataState(siteSetupState[0]?.HoleDatas);
            setTeeMarkersDataState(siteSetupState[0]?.TeeMarkers);
            setPointsOfInterestDataState(siteSetupState[0]?.PointsOfInterest);
            setTeeMarkerSeetingId(siteSetupState[0]?.TeeMarkerSettings);

            if (mapData && mapsData) {
                initializeSiteArea();
            }
        }
    }, [siteSetupState, mapData, mapsData]);

    useEffect(() => {
        if (Object.keys(siteSetupData).length > 0) {
            setSiteSetupState([siteSetupData]);
            callPolygonForSiteSetup();
        }
    }, [siteSetupData]);

    useEffect(() => {
        if (areaFilterData?.length > 0) {
            setSiteSetupState([areaFilterData]);
        }
    }, [areaFilterData]);

    useEffect(() => {
        if (!editSiteSetup.get()) {
            setEditModel(false);
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            setEditSelectedData((prevData) => {
                prevData?.setOptions({
                    editable: false,
                    fillOpacity: 0.2,
                });
            });
        }
    }, [editSiteSetup.get()]);

    useEffect(() => {
        setHoleCount(null);
    }, [siteIdValue]);

    useEffect(() => {
        if (editState.editStage) {
            let teesZones = teesZoneState?.map((item) => {
                item = item?.setOptions({ editable: false, draggable: false });
            });
            setTeesZoneState(teesZones);

            let fwyszones = fwysZoneState?.map((item) => {
                item = item?.setOptions({ editable: false, draggable: false });
            });
            setFwysZoneState(fwyszones);

            let gmszones = gmsZoneState?.map((item) => {
                item = item?.setOptions({ editable: false, draggable: false });
            });
            setGmsZoneState(gmszones);

            let extszones = extsZoneState?.map((item) => {
                item = item?.setOptions({ editable: false, draggable: false });
            });
            setExtsZoneState(extszones);

            seteditState({ editStage: false, polygonType: null });
        }
    }, [editState]);

    useEffect(() => {
        if (removeAddPolygon) {
            drawAreaPolygon?.setMap(null);
        }
    }, [drawAreaPolygon]);

    useEffect(() => {
        if (addSiteSetup.get()) {
            siteAreaDrawingEventListenerAdding();
            holeAreaDrawingEventListenerAdding();

            // resetting newly added polygon
            setCourseNameModel(1);
            setHoleNoModel(1);
            setCourseTypeModel(1);
        } else {
            mapData?.setOptions({
                draggableCursor: "grab",
                draggingCursor: "grabbing",
            });

            siteDrawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            siteDrawAreaPolygon?.setMap(null);

            drawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            drawAreaPolygon?.setMap(null);

            areaPolygons.forEach((it) => it.setMap(null));
            holePolygons.forEach((it) => it.setMap(null));
        }
    }, [addSiteSetup.get()]);

    useEffect(() => {
        if (!editSiteSetup.get() || !showAreas.get()) {
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
        }
        if (!showAreas.get() && addSiteSetup.get()) {
            areaPolygons.forEach((it) => it.setMap(null));
            holePolygons.forEach((it) => it.setMap(null));
        }
    }, [showAreas.get()]);

    useEffect(() => {
        var canEdit = (!isUserBasic(getUserRole && getUserRole?.Role) && !isUserReadOnly(getUserRole && getUserRole?.Role));

        areaPolygons?.forEach((it) => {
            it?.setOptions({
                options: {
                    editable: canEdit,
                    clickable: false,
                    strokeColor: "#663a83",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "#663a83",
                },
            });
            addListenersOnEditSiteAreaFinalPolygon(it);
        });
    }, [areaPolygons]);

    useEffect(() => {
        var canEdit = (!isUserBasic(getUserRole && getUserRole?.Role) && !isUserReadOnly(getUserRole && getUserRole?.Role));

        holePolygons?.forEach((it) => {
            it?.setOptions({
                options: {
                    editable: canEdit,
                    suppressUndo: true,
                    clickable: false,
                    strokeColor: "#00FF00",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "red",
                    cursor: "crosshair",
                },
            });
            addListenersOnEditAreaFinalPolygon(it);
        });
    }, [holePolygons]);

    useEffect(() => {
        if (kmlLayerData !== "") {
            let kml =
                mapsData &&
                new mapsData.KmlLayer({
                    url: kmlLayerData,
                    suppressInfoWindows: true,
                    preserveViewport: true,
                    clickable: false,
                    map: mapData,
                });
            setDisplayKmlLayer(kml);
        }
    }, [kmlLayerData, mapData, mapsData]);

    useEffect(() => {
        dispatch(kmlLayerDataAction(""));
        displayKmlLayer && displayKmlLayer.setMap(null);
    }, [siteId.get()]);

    useEffect(() => {
        if (overlay.get()) {
            displayKmlLayer && displayKmlLayer.setMap(mapData);
        } else {
            displayKmlLayer && displayKmlLayer.setMap(null);
        }
    }, [overlay.get(), displayKmlLayer]);

    const initializeSiteArea = () => {
        setFinalDataState(siteSetupState);

        // Tees data filter start
        initializeTees();

        // stgs data filter start
        initializeStgs();

        // fwys data filter start
        initializeFwys();

        // grns data filter start
        intializeGrns();

        // exts data filter start
        initializeExts();
    }

    const initializeTees = () => {
        let teesAreaPath = siteSetupState?.length > 0 && siteSetupState[0]?.HoleAreas?.filter((item) => item.Type === 0);
        setTeesAreaPathState(teesAreaPath);

        let teesData = teesAreaPath?.length > 0 &&
            teesAreaPath?.map((item) => {
                return item.Polygon;
            });

        let updated_teesData = teesData?.length > 0 && teesData;

        const teesPathCoords =
            mapsData && updated_teesData && updated_teesData?.length !== 0
                ? updated_teesData?.map((item4) => {
                    return item4?.map((innerItem) => {
                        return (mapsData.LatLngLiteral = {
                            lat: innerItem.Lat,
                            lng: innerItem.Lon,
                        });
                    });
                })
                : "";

        setTeesPathCoords(teesPathCoords);

        if (teesAreaPath !== undefined && showAreas.get() && teesBtn.get() && !hideAll.get() && teesZoneDisplayed.length === 0) {
            let temp = [];
            for (let i = 0; i < teesAreaPath.length; i++) {
                const teesZoneStateLocal = new mapsData.Polygon({
                    paths: teesPathCoords[i],
                    strokeColor: "#eb0c0a",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#eb0c0a",
                    fillOpacity: 0.15,
                    indexID: teesAreaPath[i].Id,
                    zIndex: 2,
                });

                teesZoneStateLocal?.setMap(mapData);
                temp = [...temp, teesZoneStateLocal];

                addListenersOnEditAreaFinalPolygon(teesZoneStateLocal);
                polygonClick(teesZoneStateLocal);
                polyMouseOver(teesZoneStateLocal);
                polyMouseOut(teesZoneStateLocal);
            }
            setTeesZoneDisplayed(temp);
        }
    }

    const initializeStgs = () => {
        let siteAreaPath = siteSetupState?.length > 0 && siteSetupState[0]?.SiteAreas?.filter((item) => item.Type === 0);
        setStgsAreaPathState(siteAreaPath);

        let siteData = siteAreaPath?.length > 0 &&
            siteAreaPath?.map((item) => {
                return item.Polygon;
            });
        let updated_siteData = siteData && siteData.length > 0 && siteData;

        const sitePathCoords =
            mapsData &&
                updated_siteData &&
                updated_siteData !== undefined &&
                updated_siteData.length !== 0
                ? updated_siteData?.map((item4) => {
                    return item4?.map((innerItem) => {
                        return (mapsData.LatLngLiteral = {
                            lat: innerItem.Lat,
                            lng: innerItem.Lon,
                        });
                    });
                })
                : "";

        setStgsPathCoords(sitePathCoords);

        if (siteAreaPath !== undefined && showAreas.get() && stgsBtn.get() && !hideAll.get() && stgsZoneDisplayed.length === 0) {
            let temp = [];
            for (let i = 0; i < siteAreaPath.length; i++) {
                const siteAreaDemo = new mapsData.Polygon({
                    paths: sitePathCoords[i],
                    strokeColor: "#663a83",
                    strokeOpacity: 0.9,
                    strokeWeight: 2,
                    fillColor: "#663a83",
                    fillOpacity: 0.15,
                    indexID: siteAreaPath[i].Id
                });

                siteAreaDemo?.setMap(mapData);
                temp = [...temp, siteAreaDemo];
                addListenersOnEditSiteAreaFinalPolygon(siteAreaDemo);
                addListenersOnEditSiteAreaChangesPolygon(siteAreaDemo);
                polygonClick(siteAreaDemo);
                polyMouseOver(siteAreaDemo);
                polyMouseOut(siteAreaDemo);
            }
            setStgsZoneDisplayed(temp);
        }
    }

    const initializeFwys = () => {
        let fwysAreaPath = siteSetupState?.length > 0 && siteSetupState[0]?.HoleAreas?.filter((item) => item.Type === 1);
        let fwysData = fwysAreaPath?.length > 0 &&
            fwysAreaPath?.map((item) => {
                return item.Polygon;
            });

        setFwysAreaPathState(fwysAreaPath);

        let updated_fwysData = fwysData && fwysData.length > 0 && fwysData;

        const fwysPathCoords =
            mapsData &&
                updated_fwysData &&
                updated_fwysData !== undefined &&
                updated_fwysData.length !== 0
                ? updated_fwysData?.map((item4) => {
                    return item4?.map((innerItem) => {
                        return (mapsData.LatLngLiteral = {
                            lat: innerItem.Lat,
                            lng: innerItem.Lon,
                        });
                    });
                })
                : "";

        setFwysPathCoords(fwysPathCoords);

        if (fwysAreaPath !== undefined && showAreas.get() && fwysBtn.get() && !hideAll.get() && fwysZoneDisplayed.length === 0) {
            let temp = [];
            for (let i = 0; i < fwysPathCoords.length; i++) {
                const fwysZoneStateLocal = new mapsData.Polygon({
                    paths: fwysPathCoords[i],
                    strokeColor: "#f0f004",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#f0f004",
                    fillOpacity: 0.15,
                    indexID: fwysAreaPath[i].Id,
                    zIndex: 4,
                });
                fwysZoneStateLocal?.setMap(mapData);
                temp = [...temp, fwysZoneStateLocal];
                addListenersOnEditAreaFinalPolygon(fwysZoneStateLocal, fwysPathCoords);
                polygonClick(fwysZoneStateLocal);
                polyMouseOver(fwysZoneStateLocal);
                polyMouseOut(fwysZoneStateLocal);
            }
            setFwysZoneDisplayed(temp);
        }
    }

    const intializeGrns = () => {
        let grnsAreaPath = siteSetupState?.length > 0 && siteSetupState[0]?.HoleAreas?.filter((item) => item.Type === 2);
        let grnsData = grnsAreaPath?.length > 0 &&
            grnsAreaPath?.map((item) => {
                return item.Polygon;
            });

        setGmsAreaPathState(grnsAreaPath);

        let updated_grnsData = grnsData && grnsData.length > 0 && grnsData;

        const grnsPathCoords =
            mapsData &&
                updated_grnsData &&
                updated_grnsData !== undefined &&
                updated_grnsData.length !== 0
                ? updated_grnsData?.map((item4) => {
                    return item4?.map((innerItem) => {
                        return (mapsData.LatLngLiteral = {
                            lat: innerItem.Lat,
                            lng: innerItem.Lon,
                        });
                    });
                })
                : "";

        setGmsPathCoords(grnsPathCoords);


        if (grnsAreaPath !== undefined && showAreas.get() && gmsBtn.get() && !hideAll.get() && gmsZoneDisplayed.length === 0) {
            let temp = [];

            for (let i = 0; i < grnsAreaPath.length; i++) {
                const gmsZoneStateLocal = new mapsData.Polygon({
                    paths: grnsPathCoords[i],
                    strokeColor: "#067c05",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#067c05",
                    fillOpacity: 0.15,
                    indexID: grnsAreaPath[i].Id,
                    zIndex: 3,
                });
                gmsZoneStateLocal?.setMap(mapData);
                temp = [...temp, gmsZoneStateLocal];

                addListenersOnEditAreaFinalPolygon(gmsZoneStateLocal, grnsPathCoords);
                polygonClick(gmsZoneStateLocal);
                polyMouseOver(gmsZoneStateLocal);
                polyMouseOut(gmsZoneStateLocal);
            }
            setGmsZoneDisplayed(temp);
        }
    }

    const initializeExts = () => {
        let extsAreaPath = siteSetupState?.length > 0 && siteSetupState[0]?.HoleAreas?.filter((item) => item.Type === 3);
        let extsData = extsAreaPath?.length > 0 &&
            extsAreaPath?.map((item) => {
                return item.Polygon;
            });

        setExtsAreaPathState(extsAreaPath);
        let updated_extsData = extsData && extsData.length > 0 && extsData;

        const extsPathCoords =
            mapsData &&
                updated_extsData &&
                updated_extsData !== undefined &&
                updated_extsData.length !== 0
                ? updated_extsData?.map((item4) => {
                    return item4?.map((innerItem) => {
                        return (mapsData.LatLngLiteral = {
                            lat: innerItem.Lat,
                            lng: innerItem.Lon,
                        });
                    });
                })
                : "";

        setExtsPathCoords(extsPathCoords);


        if (extsAreaPath !== undefined && showAreas.get() && extsBtn.get() && !hideAll.get() && extsZoneDisplayed.length === 0) {
            let temp = [];
            for (let i = 0; i < extsAreaPath.length; i++) {
                const extsZoneStateLocal = new mapsData.Polygon({
                    paths: extsPathCoords[i],
                    strokeColor: "#0202f2",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#0202f2",
                    fillOpacity: 0.15,
                    indexID: extsAreaPath[i].Id,
                    zIndex: 1,
                });


                extsZoneStateLocal?.setMap(mapData);
                temp = [...temp, extsZoneStateLocal];
                addListenersOnEditAreaFinalPolygon(extsZoneStateLocal, extsPathCoords);
                polygonClick(extsZoneStateLocal);
                polyMouseOver(extsZoneStateLocal);
                polyMouseOut(extsZoneStateLocal);
            }
            setExtsZoneDisplayed(temp);
        }
    }

    const polygonClick = (data) => {
        mapsData.event.addListener(data, "contextmenu", (e) => {
            if (enableClickToDriveFeature.get() && data) {
                clickToDrivefeature(e);
            }
        });
    }

    const polyMouseOver = (polygon) => {
        mapsData.event.addListener(polygon, "mouseover", () => {
            if (enableClickToDriveFeature.get() && polygon != null) {
                polygon.setOptions({ cursor: "alias" });
            }
            if (polygon != null) {
                polygon.setOptions({
                    fillOpacity: 0.6,
                });
            }
        });
    }

    const polyMouseOut = (polygon) => {
        mapsData.event.addListener(polygon, "mouseout", () => {
            if (polygon != null) {
                polygon.setOptions({
                    fillOpacity: 0.15,
                });
            }
        });
    }

    const clickToDrivefeature = (event) => {
        if (showTaggedCarArrayClickToDriveInputValueSetter.get().length !== 0 && enableClickToDriveFeature.get()) {
            let carIdArray = [...showTaggedCarArrayClickToDriveInputValueSetter.get()];

            let carIds = carIdArray.toString();
            let carLat = event.latLng.lat();
            let carLng = event.latLng.lng();

            if (carIds && carLat && carLng) {
                setCarSnackbarInfo({
                    lng: carLng,
                    lat: carLat,
                });

                dispatch(COMMON_SERVICES.setClickToDriveServices(carIds, carLat, carLng, siteIdValue));

                setSnackbarState({ ...snackbarState, openSnackbar: true });
            }
        } else {
            if (enableClickToDriveFeature.get()) {
                setCTDModal(true);
            }
        }
    }

    const callPolygonForSiteSetup = () => {
        displayHideAreaPolygon(
            extsBtn.get(),
            extsAreaPathState,
            extsPathCoordsState,
            extsZoneDisplayed,
            setExtsZoneDisplayed,
            "#0202f2",
            1,
            mapData,
            mapsData,
            addListenersOnEditSiteAreaChangesPolygon,
            addListenersOnEditSiteAreaFinalPolygon,
            addListenersOnEditAreaFinalPolygon,
            polygonClick,
            polyMouseOver,
            polyMouseOut,
            showAreas.get()
        );

        displayHideAreaPolygon(
            teesBtn.get(),
            teesAreaPathState,
            teesPathCoordsState,
            teesZoneDisplayed,
            setTeesZoneDisplayed,
            "#eb0c0a",
            2,
            mapData,
            mapsData,
            addListenersOnEditSiteAreaChangesPolygon,
            addListenersOnEditSiteAreaFinalPolygon,
            addListenersOnEditAreaFinalPolygon,
            polygonClick,
            polyMouseOver,
            polyMouseOut,
            showAreas.get()
        );

        displayHideAreaPolygon(
            gmsBtn.get(),
            gmsAreaPathState,
            gmsPathCoordsState,
            gmsZoneDisplayed,
            setGmsZoneDisplayed,
            "#067c05",
            3,
            mapData,
            mapsData,
            addListenersOnEditSiteAreaChangesPolygon,
            addListenersOnEditSiteAreaFinalPolygon,
            addListenersOnEditAreaFinalPolygon,
            polygonClick,
            polyMouseOver,
            polyMouseOut,
            showAreas.get()
        );

        displayHideAreaPolygon(
            fwysBtn.get(),
            fwysAreaPathState,
            fwysPathCoordsState,
            fwysZoneDisplayed,
            setFwysZoneDisplayed,
            "#f0f004",
            4,
            mapData,
            mapsData,
            addListenersOnEditSiteAreaChangesPolygon,
            addListenersOnEditSiteAreaFinalPolygon,
            addListenersOnEditAreaFinalPolygon,
            polygonClick,
            polyMouseOver,
            polyMouseOut,
            showAreas.get()
        );

        if (!hideAll.get()) {
            displayHideAreaPolygon(
                stgsBtn.get(),
                stgsAreaPathState,
                stgsPathCoordsState,
                stgsZoneDisplayed,
                setStgsZoneDisplayed,
                "#663a83",
                5,
                mapData,
                mapsData,
                addListenersOnEditSiteAreaChangesPolygon,
                addListenersOnEditSiteAreaFinalPolygon,
                addListenersOnEditAreaFinalPolygon,
                polygonClick,
                polyMouseOver,
                polyMouseOut,
                showAreas.get()
            );
        }
    }

    const shouldShowMapCenterMarker = () => {
        return !siteLocationGlobalData.get() && showCenterOfGreens.get() && (!hideAll.get() || holeView.get()) && centerGreenDataState && centerGreenDataState.length !== 0;
    }

    const showNewAreaPolygon = () => {
        drawAreaPolygon && drawAreaPolygon.setMap(mapData);
    }

    const hideNewAreaPolygon = () => {
        drawAreaPolygon && drawAreaPolygon.setMap(null);
    }

    const showSiteAreaPolygon = () => {
        siteDrawAreaPolygon && siteDrawAreaPolygon.setMap(mapData);
    }

    const hideSiteAreaPolygon = () => {
        siteDrawAreaPolygon && siteDrawAreaPolygon.setMap(null);
    }

    const shouldShowTeeMarker = () => {
        return !siteLocationGlobalData.get() && showTeeMarkers.get() &&
            (!hideAll.get() || holeView.get()) && teeMarkersDataState && teeMarkersDataState.length !== 0;
    }

    const shouldShowPointsOfInterestMarker = () => {
        return !siteLocationGlobalData.get() && showPointsOfInterest.get() &&
            (!hideAll.get() || holeView.get()) && pointsOfInterestDataState && pointsOfInterestDataState.length !== 0;
    }

    const shouldShowHoleMarker = () => {
        return !siteLocationGlobalData.get() && holeMarkerData && showHoleMarker && holeMarkerData.length !== 0;
    }

    const shouldShowNewPointMarker = () => {
        return !siteLocationGlobalData.get() && ourData?.poi && ourData?.poi.length !== 0;
    }

    const shouldShowNewMapTeeMarker = () => {
        return !siteLocationGlobalData.get() && ourData?.tee?.length !== 0;
    }

    const shouldShowCogMarker = () => {
        return !siteLocationGlobalData.get() && ourData?.cog && ourData?.cog.length !== 0;
    }

    const onSiteAreaMarkerEnter = (childKey, mouse, markerName) => {
        const latitude = mouse?.latLng?.lat();
        const longitude = mouse?.latLng?.lng();

        if (markerName === "tee" && teeMarkersDataState) {
            let index = teeMarkersDataState?.findIndex((it) => it.Id === childKey);
            let data = JSON.parse(JSON.stringify(teeMarkersDataState));

            if (data[index]) {
                data[index].Lat = latitude;
                data[index].Lon = longitude;
            }

            setTeeMarkersDataState(data);
            setSetting({ draggable: false });
        } else if (markerName === "poi" && pointsOfInterestDataState) {
            let index = pointsOfInterestDataState?.findIndex((it) => it.Id === childKey);
            let data = JSON.parse(JSON.stringify(pointsOfInterestDataState));

            if (data[index]) {
                data[index].Lat = latitude;
                data[index].Lon = longitude;
            }

            setPointsOfInterestDataState(data);
            setSetting({ draggable: false });
        } else if (markerName === "cog" && centerGreenDataState) {
            let index = centerGreenDataState?.findIndex((it) => it.Id === childKey);
            let data = JSON.parse(JSON.stringify(centerGreenDataState));

            if (data[index]) {
                data[index].Lat = latitude;
                data[index].Lon = longitude;
            }

            setCenterGreenDataState(data);
            setSetting({ draggable: false });
        }

        if (showCenterOfGreens.get()) {
            const updatedValue = JSON.parse(JSON.stringify(centerGreenDataState));
            let addValue = updatedValue.map((x) => ({ ...x, draggable: false }));
            let filterValue = addValue.filter((item) => item.Id === childKey);
            let updatedCoords = filterValue.map((x) => ({
                ...x,
                CogLat: latitude,
                CogLon: longitude,
            }));

            let objIndex = updatedValue?.findIndex((obj) => obj.Id === updatedCoords[0]?.Id);
            addValue[objIndex] = updatedCoords[0];
            setCenterGreenDataState(addValue);
        } else if (showTeeMarkers.get()) {
            const updatedValue = JSON.parse(JSON.stringify(teeMarkersDataState));
            let addValue = updatedValue.map((x) => ({ ...x, draggable: false }));
            let filterValue = addValue.filter((item) => item.Id === childKey);
            let updatedCoords = filterValue.map((x) => ({
                ...x,
                Lat: latitude,
                Lon: longitude,
            }));
            let objIndex = updatedValue?.findIndex((obj) => obj.Id === updatedCoords[0]?.Id);

            if (objIndex) {
                addValue[objIndex] = updatedCoords[0];
                setTeeMarkersDataState(addValue);
            }
        } else if (showPointsOfInterest.get()) {
            const updatedValue = JSON.parse(
                JSON.stringify(pointsOfInterestDataState)
            );
            let addValue = updatedValue.map((x) => ({ ...x, draggable: false }));
            let filterValue = addValue.filter((item) => item.Id === childKey);
            let updatedCoords = filterValue.map((x) => ({
                ...x,
                Lat: latitude,
                Lon: longitude,
            }));
            let objIndex = updatedValue?.findIndex((obj) => obj.Id === updatedCoords[0]?.Id);
            addValue[objIndex] = updatedCoords[0];
            setPointsOfInterestDataState(addValue);
        }
    }

    const onSiteAreaMarkerLeave = (childKey, childProps, mouse, markerName) => {
        if (clickWindowState.get()) return;

        const latitude = mouse?.latLng?.lat();
        const longitude = mouse?.latLng?.lng();

        setEditModel(false);

        setSiteSetupDialogBox({ lat: latitude, lng: longitude });

        setSetting({ draggable: true });

        openEditModal(
            markerName,
            editSiteSetup,
            setModalState,
            showCenterOfGreens,
            showTeeMarkers,
            showPointsOfInterest,
            setOpenModel,
            setOpenAreaWindow,
            setEditModel
        );

        handleEditCourseChange(childProps?.Course);
        setEditHoleNo(childProps?.Hole);
        setPoiEditTypeCopy(childProps?.Type);
        setPoiEditTypeValue(childProps?.Type);
        typeHole.set(childProps?.Type);
        setEditLatLng({ lat: latitude, lng: longitude });
        setDeleteId(childKey);
        setEditId(childKey);
        imagePreview(childProps);
    }

    const onMarkerMouseClick = (e, item, markerName) => {
        carPopupClickEvent.set(null);

        if (editSiteSetup.get()) {
            onSiteAreaMarkerEnter(item.Id, e, markerName);
            onSiteAreaMarkerLeave(item.Id, item, e, markerName);
        }

        if (!clickWindowState.get()) {
            imagePreview(item);
        }
    }

    return (
        <>
            {addSiteSetup.get() && addSelectType.get() === siteSettingsTypes.holeArea
                ? showNewAreaPolygon()
                : hideNewAreaPolygon()
            }

            {addSiteSetup.get() && addSelectType.get() === siteSettingsTypes.siteAreaType
                ? showSiteAreaPolygon()
                : hideSiteAreaPolygon()
            }

            {shouldShowMapCenterMarker() &&
                centerGreenDataState.map((item) => {
                    const lat = item?.CogLat;
                    const lng = item?.CogLon;

                    return (<AdvancedMarker position={{ lat, lng }} key={`Map Center: ${item.Id}`} onClick={(e) => onMarkerMouseClick(e, item, "cog")}>
                        <MapCenterMarker
                            key={item.Id}
                            markerName="cog"
                            lat={lat}
                            lng={lng}
                            uniqueId={uuid()}
                            courseNumber={item?.Course}
                            holeNumber={item?.Hole}
                        />
                    </AdvancedMarker>
                    );
                })
            }

            {shouldShowTeeMarker() &&
                teeMarkersDataState.map((item) => {
                    const lat = item?.Lat;
                    const lng = item?.Lon;

                    return (
                        <AdvancedMarker position={{ lat, lng }} key={`Map Tee: ${item.Id}`} onClick={(e) => onMarkerMouseClick(e, item, "tee")}>
                            <MapTeesMarker
                                key={item.Id}
                                markerName="tee"
                                teeMarkColorId={teeMarkeSeetingId}
                                lat={item?.Lat}
                                lng={item?.Lon}
                                uniqueId={uuid()}
                                teeMarkerSeetingId={item?.TeeMarkerSettingId}
                                courseNumber={item?.Course}
                                holeNumber={item?.Hole}
                            />
                        </AdvancedMarker>
                    )
                })
            }

            {shouldShowPointsOfInterestMarker() &&
                pointsOfInterestDataState.map((item) => {
                    const lat = item?.Lat;
                    const lng = item?.Lon;

                    return (
                        <AdvancedMarker position={{ lat, lng }} key={`Map Point: ${item.Id}`} onClick={(e) => onMarkerMouseClick(e, item, "poi")}>
                            <MapPointMarker
                                key={item.Id}
                                markerName="poi"
                                lat={item?.Lat}
                                lng={item?.Lon}
                                uniqueId={uuid()}
                                type={item?.Type}
                                position={item?.LabelPosition}
                                courseNumber={item?.Course}
                                holeNumber={item?.Hole}
                            />
                        </AdvancedMarker>
                    )
                })
            }

            {shouldShowHoleMarker() &&
                holeMarkerData.map((item) => {
                    const lat = item?.Latitude;
                    const lng = item?.Longitude;

                    return (
                        <AdvancedMarker position={{ lat, lng }} key={`Map Hole: ${item.Id}`} onClick={(e) => onMarkerMouseClick(e, item)}>
                            <MapHoleMarker
                                key={item.Id}
                                lat={item?.Latitude}
                                lng={item?.Longitude}
                                uniqueId={uuid()}
                                courseNumber={item?.Course}
                                holeNumber={item?.Hole}
                            />
                        </AdvancedMarker>
                    )
                })
            }

            {shouldShowNewPointMarker() &&
                ourData?.poi?.map((el) => {
                    const lat = el?.lat;
                    const lng = el?.lng;

                    return (
                        <AdvancedMarker position={{ lat, lng }} key={`New Map Point: ${el.Id}`} onClick={(e) => onMarkerMouseClick(e, el)}>
                            <NewMapPointMarker
                                lat={el?.lat}
                                lng={el?.lng}
                                uniqueId={uuid()}
                                type={poiTypeValue}
                                position={poiPositionValue}
                            />
                        </AdvancedMarker>
                    );
                })}

            {shouldShowNewMapTeeMarker() &&
                ourData?.tee?.map((el) => {
                    const lat = el?.lat;
                    const lng = el?.lng;

                    return (
                        <AdvancedMarker position={{ lat, lng }} key={`New Map Tee: ${el.Id}`} onClick={(e) => onMarkerMouseClick(e, el)}>
                            <NewMapTeesMarker
                                lat={el?.lat}
                                lng={el?.lng}
                                uniqueId={uuid()}
                                teeMarkerSeetingId={teeValue}
                                holeNumber={holeNo}
                            />
                        </AdvancedMarker>
                    );
                })}

            {shouldShowCogMarker() &&
                ourData?.cog?.map((el, index) => {
                    const lat = el?.lat;
                    const lng = el?.lng;

                    return (
                        <AdvancedMarker position={{ lat, lng }} key={`Map Center cog: ${index}`} onClick={(e) => onMarkerMouseClick(e, el)}>
                            <MapCenterMarker lat={el?.lat} lng={el?.lng} uniqueId={uuid()} />
                        </AdvancedMarker>
                    );
                })}
        </>);
}